import overArg from './_overArg.js';

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

export default getPrototype;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/lodash-es/_getPrototype.js
// module id = 6hRR
// module chunks = 1